import { Button } from '@/components/Button';
import { Modal } from '@/components/Modal';
import { Text } from '@/components/Text';
import { useEventStore } from '@/stores/useEventStore';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

export const UpdateEventGeneralDelete = () => {
  const { t, i18n } = useTranslation();
  const { deleteEvent } = useEventStore();
  const { id } = useParams();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDelete = async () => {
    try {
      await deleteEvent(Number(id));
      navigate(`/${i18n.language}/dashboard/events/events-management`);
    } catch (error) {
      console.error("Erreur lors de la suppression de l'événement:", error);
    }
  };

  const handleOpen = () => {
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="mb-4">
        <Text className="text-lg font-semibold text-secondary">
          {t('updateEvent:general.delete.title')}
        </Text>
        <Text className="text-sm font-light text-gray-light">
          {t('updateEvent:general.delete.description')}
        </Text>
      </div>
      <div className="flex">
        <Button className="w-full bg-danger lg:w-auto" onClick={handleOpen}>
          {t('updateEvent:general.delete.button')}
        </Button>
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={handleClose}
        className="w-auto"
        title={t('updateEvent:general.delete.title')}
      >
        <p className="mb-4 text-gray-600">
          {t('updateEvent:general.delete.description')}
        </p>
        <div className="mt-6 flex flex-row items-center justify-end space-x-3">
          <Button onClick={handleClose}>{t('common:cancel')}</Button>
          <Button className="bg-danger" onClick={handleDelete}>
            {t('common:confirm')}
          </Button>
        </div>
      </Modal>
    </>
  );
};
